// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';
import './fslightbox-3.8.3.js';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

htmx.config.globalViewTransitions = true;
window.Alpine = Alpine;

Alpine.plugin(collapse);

Alpine.start();

document.addEventListener('DOMContentLoaded', function () {
    
    const galleryToggle = document.getElementById('gallery-toggle');
    if (galleryToggle) {
        const productGallery = new window.FsLightbox();
        productGallery.props.sources = window.productImages || [];
        productGallery.props.thumbs = window.productGalleryThumbs || [];
        productGallery.props.showThumbsOnMount = true;
        refreshFsLightbox();

        galleryToggle.addEventListener('click', (event) => {
            event.preventDefault();
            productGallery.open();
        });
    }

    // Accordion block JS & Product Page accordions
    var acc = document.getElementsByClassName("accordion-toggle");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
            } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    const fiftyFiftyPatterns = document.querySelectorAll('.fifty-fifty-pattern');

    if (fiftyFiftyPatterns) {
        fiftyFiftyPatterns.forEach((el) => {
            const images = el.querySelectorAll('img');
            images?.forEach((img) => {
                img.setAttribute('srcset', '');
                img.setAttribute('sizes', '');
            })
        })
    }
});
